<ts-dialog suppressHeader="true">
  <div class="flex flex-row justify-center items-center w-full gap-4" ts-dialog-body>
    <div class="w-2/3 m-10">
      <ts-panel [title]="panelFormControls.title.value || '-'" [headerColor]="this.panelFormControls.headerColor.value">
        <!--    Height must be fixed for the charts -->
        <section ts-panel-content class="h-128 overflow-y-auto">
          <financial-statement-grid
            [ngStyle]="{
              zoom: '80%',
              display:
                this.panelFormControls.type.valid && this.panelFormControls.reportPeriod.valid ? 'block' : 'none',
            }"
            [reportPeriod]="this.reportPeriodValues[panelFormControls.reportPeriod.value]"
            [loading]="previewLoading$ | async"
            [displayHeader]="false"
            [mode]="panelFormControls.type.value"
            [financialStatement]="financialStatementPreview$ | async"
          />
          @if (!this.panelFormControls.type.valid || !this.panelFormControls.reportPeriod.valid) {
            <ng-container *ngTemplateOutlet="emptyState"></ng-container>
          }
        </section>
      </ts-panel>
    </div>
    <div class="w-1/3 h-full self-start p-4 flex flex-col gap-4 border border-black-200 rounded">
      <!-- STEP 1: Panel Configuration -->
      <form class="flex flex-col gap-4" [formGroup]="panelForm">
        <p class="text-2xl font-bold">Panel Configuration</p>
        <div class="w-full flex flex-col gap-2 items-center">
          <ts-input
            placeholder="Panel Title"
            class="w-full"
            type="text"
            [formControl]="panelFormControls.title"
            [roundedBorders]="false"
          ></ts-input>
          <!-- TODO: create an ng-template reusable thing -->
          <ts-select
            [items]="accountColorOptions$ | async"
            itemKey="name"
            itemLabel="label"
            class="w-full"
            formControlName="headerColor"
            [uiOptions]="{
              roundedBorders: false,
              placeholder: 'Header Color',
              searchPlaceholder: 'Search for a Panel Type...',
              size: 'small',
            }"
          />

          <ts-select
            [items]="financialReportOptions"
            itemKey="value"
            itemLabel="label"
            class="w-full"
            formControlName="type"
            [uiOptions]="{
              roundedBorders: false,
              placeholder: 'Financial Report Type',
              searchPlaceholder: 'Search for a Financial Report Type...',
              size: 'small',
            }"
          >
          </ts-select>

          <ts-select
            itemKey="key"
            itemLabel="label"
            class="w-full"
            [formControl]="panelFormControls.reportPeriod"
            [hasGroups]="false"
            [uiOptions]="{
              roundedBorders: false,
              placeholder: 'Select a period',
              searchPlaceholder: 'Select period...',
              size: 'full',
            }"
            [items]="reportPeriodOptions"
          ></ts-select>
        </div>
      </form>
    </div>
  </div>

  <div class="ts-dialog-actions-container" ts-dialog-actions>
    <ts-button variant="secondary" (click)="dialogRef.close()">Cancel</ts-button>
    <ts-button variant="primary" [disabled]="panelForm.invalid" (click)="createPanel()">Save</ts-button>
  </div>
</ts-dialog>

<ng-template #emptyState>
  <ts-empty-state
    icon="ts_graph-bar"
    title="Preview Unavailable"
    subtitle="Keep editing the panel's configuration"
  ></ts-empty-state>
</ng-template>
